import {
  AdvertiserAccountType,
  AdvertiserAccountTypeLabel,
} from '@/common/permission'

export const currencyList = [
  {
    value: 1,
    label: 'USD($)',
  },
  {
    value: 2,
    label: 'CNY(￥)',
  },
]

export const isPrePayList = [
  {
    value: 1,
    label: '是',
  },
  {
    value: 2,
    label: '否',
  },
]

export const accountTypeList = [
  {
    value: 1,
    label: 'Monthly',
  },
  {
    value: 2,
    label: 'Weekly',
  },
]

export const mwsAccountTypeList = [
  {
    value: AdvertiserAccountType.Normal,
    label: AdvertiserAccountTypeLabel[AdvertiserAccountType.Normal],
  },
  {
    value: AdvertiserAccountType.Internal,
    label: AdvertiserAccountTypeLabel[AdvertiserAccountType.Internal],
  },
]
